import apiDepartment from '@/api/department'
export default [
  {
    path: '/departments',
    name: 'department',
    meta: { requiresAuth: true },
    component: () => import('@/pages/department/index.vue')
  },
  {
    path: '/departments/:id',
    name: 'department-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/department/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await apiDepartment.find(to.params.id)
      to.params.editData = response.data
      next()
    }
  }
]
